import PromotionListAction from '../../prat_actions/promotion/promotionListAction'

const PromotionListReducer = (state = {isPromotionListLoading: true,promotionListHasError:false,deletingPromotion:false,promotionDeletedSuccessfully:false,
errorDeletingPromotion:false,bulkApproving:false,bulkDuplicating:false,bulkDuplicatedSuccessfully:false,bulkSendBack:false,bulkSendBackSuccessfully:false,
bulkRpCallLoading:false, bulkRpCallSuccessfully:false, bulkDuplicatedNextYearSuccessfully:false, bulkDuplicatingNextYear:false,
bulkCalculatePreOpsoSuccessfully:false }, action ) => {
    // let details;
    // console.log(action.type)
    switch (action.type) {

        case PromotionListAction.GET_PROMOTION_LIST_REQUEST :
            return {
                ...state,
                isPromotionListLoading:true,
                promotionList:action.data,
                promotionListHasError:false
            };        

        case PromotionListAction.GET_PROMOTION_LIST_SUCCESS :
            // console.log(action.data)
            return {
                ...state,
                isPromotionListLoading:false,
                promotionList:action.data,
                promotionListHasError:false
            };  
            
        case PromotionListAction.GET_PROMOTION_LIST_FAILED:
            return {
                ...state,
                isPromotionListLoading:false,
                promotionList:action.error,
                promotionListHasError:true
            };


        //DELETE PROMOTION

        case PromotionListAction.DELETE_PROMOTION_REQUEST :
            return {
                ...state,
                deletingPromotion:true,
                promotionDeletedSuccessfully:false,
                errorDeletingPromotion:false
            };        

        case PromotionListAction.DELETE_PROMOTION_SUCCESS :
            return {
                ...state,
                deletingPromotion:false,
                promotionDeletedSuccessfully:true,
                errorDeletingPromotion:false
            };  
            
        case PromotionListAction.DELETE_PROMOTION_FAILED:
            return {
                ...state,
                deletingPromotion:false,
                error:action.error,
                promotionDeletedSuccessfully:false,
                errorDeletingPromotion:true
            };


        //BULK APPROVE PROMOTION

        case PromotionListAction.BULK_APPROVE_PROMOTION_REQUEST :
            return {
                ...state,
                bulkApproving:true
            };        

        case PromotionListAction.BULK_APPROVE_PROMOTION_SUCCESS :
            return {
                ...state,
                bulkApproving:false
            };  
            
        case PromotionListAction.BULK_APPROVE_PROMOTION_FAILED:
            return {
                ...state,
                error:action.error,
                bulkApproving:false
            };


        //BULK DUPLICATE PROMOTION

        case PromotionListAction.BULK_DUPLICATE_PROMOTION_REQUEST :
            return {
                ...state,
                bulkDuplicating:true,
                bulkDuplicatedSuccessfully:false
            };        

        case PromotionListAction.BULK_DUPLICATE_PROMOTION_SUCCESS :
            return {
                ...state,
                bulkDuplicating:false,
                bulkDuplicatedSuccessfully:true
            };  
            
        case PromotionListAction.BULK_DUPLICATE_PROMOTION_FAILED:
            return {
                ...state,
                error:action.error,
                bulkDuplicating:false,
                bulkDuplicatedSuccessfully:false
            };


        //BULK SEND BACK PROMOTION

        case PromotionListAction.BULK_SEND_BACK_PROMOTION_REQUEST :
            return {
                ...state,
                bulkSendingBack:true,
                bulkSendBackSuccessfully:false
            };        

        case PromotionListAction.BULK_SEND_BACK_PROMOTION_SUCCESS :
            return {
                ...state,
                bulkSendingBack:false,
                bulkSendBackSuccessfully:true
            };  
            
        case PromotionListAction.BULK_SEND_BACK_PROMOTION_FAILED:
            return {
                ...state,
                error:action.error,
                bulkSendingBack:false,
                bulkSendBackSuccessfully:false
            };
        
        // promotion extension 

        case PromotionListAction.PROMOTION_EXTENSION_REQUEST :
            return {
                ...state,
                // bulkSendingBack:true,
                promotion_extension:undefined,
                loading:true
            };        

        case PromotionListAction.PROMOTION_EXTENSION_SUCCESS :
            return {
                ...state,
                // bulkSendingBack:false,
                promotion_extension:true
            };  
            
        case PromotionListAction.PROMOTION_EXTENSION_FAILED:
            return {
                ...state,
                error:action.error,
                // bulkSendingBack:false,
                // bulkSendBackSuccessfully:false
            };


        //BULK RP CALL PROMOTION

        case PromotionListAction.BULK_RP_CALL_REQUEST :
            return {
                ...state,
                bulkRpCallLoading:true,
                bulkRpCallSuccessfully:false
            };        

        case PromotionListAction.BULK_RP_CALL_SUCCESS :
            return {
                ...state,
                bulkRpCallLoading:false,
                bulkRpCallSuccessfully:true
            };  
            
        case PromotionListAction.BULK_RP_CALL_FAILED:
            return {
                ...state,
                error:action.error,
                bulkRpCallLoading:false,
                bulkRpCallSuccessfully:false
            };


            //BULK DUPLICATE NEXT YEAR PROMOTION
    
            case PromotionListAction.BULK_DUPLICATE_NEXT_YEAR_PROMOTION_REQUEST :
                return {
                    ...state,
                    bulkDuplicatingNextYear:true,
                    bulkDuplicatedNextYearSuccessfully:false
                };        
    
            case PromotionListAction.BULK_DUPLICATE_NEXT_YEAR_PROMOTION_SUCCESS :
                return {
                    ...state,
                    bulkDuplicatingNextYear:false,
                    bulkDuplicatedNextYearSuccessfully:true
                };  
                
            case PromotionListAction.BULK_DUPLICATE_NEXT_YEAR_PROMOTION_FAILED:
                return {
                    ...state,
                    error:action.error,
                    bulkDuplicatingNextYear:false,
                    bulkDuplicatedNextYearSuccessfully:false
                };


                //BULK CALCULATE PRE-OPSO
        
                case PromotionListAction.BULK_CALCULATE_PROMOTION_REQUEST :
                    return {
                        ...state,
                        bulkCalculatePreOpso:true,
                        bulkCalculatePreOpsoSuccessfully:false
                    };        
        
                case PromotionListAction.BULK_CALCULATE_PROMOTION_SUCCESS :
                    return {
                        ...state,
                        bulkCalculatePreOpso:false,
                        bulkCalculatePreOpsoSuccessfully:true
                    };  
                    
                case PromotionListAction.BULK_CALCULATE_PROMOTION_FAILED:
                    return {
                        ...state,
                        error:action.error,
                        bulkCalculatePreOpso:false,
                        bulkCalculatePreOpsoSuccessfully:false
                    };

        default:
            return {
                ...state
            };
    }
}

export default PromotionListReducer;